import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import NotificationIndicator from '../../../components/ui/NotificationIndicator';

const QuickActionTiles = ({ notifications }) => {
  const navigate = useNavigate();

  const actions = [
    {
      id: 'schedule',
      title: 'Schedule Time',
      description: 'Plan your next intimate moment',
      icon: 'Calendar',
      color: 'primary',
      path: '/intimacy-scheduler',
      notificationCount: notifications?.schedule
    },
    {
      id: 'mood',
      title: 'Log Mood',
      description: 'Share how you\'re feeling today',
      icon: 'Heart',
      color: 'accent',
      path: '/mood-tracker',
      notificationCount: notifications?.mood
    },
    {
      id: 'communicate',
      title: 'Communicate',
      description: 'Share desires with AI assistance',
      icon: 'MessageCircle',
      color: 'secondary',
      path: '/ai-communication-hub',
      notificationCount: notifications?.communication
    },
    {
      id: 'history',
      title: 'View History',
      description: 'Track your intimate journey',
      icon: 'Clock',
      color: 'muted',
      path: '/encounter-management',
      notificationCount: notifications?.history
    }
  ];

  const handleActionClick = (path) => {
    navigate(path);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {actions?.map((action) => (
        <button
          key={action?.id}
          onClick={() => handleActionClick(action?.path)}
          className="relative bg-card rounded-lg border border-border p-4 md:p-6 text-left hover:shadow-therapeutic transition-therapeutic group"
        >
          {action?.notificationCount > 0 && (
            <NotificationIndicator 
              count={action?.notificationCount} 
              type={action?.id === 'mood' ? 'mood' : action?.id === 'communicate' ? 'communication' : 'default'}
            />
          )}

          <div className={`flex items-center justify-center w-12 h-12 md:w-14 md:h-14 bg-${action?.color}/10 rounded-md mb-3 md:mb-4 group-hover:scale-110 transition-therapeutic`}>
            <Icon name={action?.icon} size={24} color={`var(--color-${action?.color})`} />
          </div>

          <h3 className="text-base md:text-lg lg:text-xl font-heading font-semibold text-foreground mb-1 md:mb-2">
            {action?.title}
          </h3>
          
          <p className="text-xs md:text-sm text-muted-foreground font-caption">
            {action?.description}
          </p>

          <div className="mt-3 md:mt-4 flex items-center gap-2 text-primary text-sm md:text-base font-medium">
            <span>Get Started</span>
            <Icon name="ArrowRight" size={16} color="currentColor" className="group-hover:translate-x-1 transition-therapeutic" />
          </div>
        </button>
      ))}
    </div>
  );
};

export default QuickActionTiles;